import { get } from 'lodash';
import React, { FC, useEffect, useState } from 'react';
import GetRecords from '../../../../../../../lib/api/GetRecords';
import { APIS } from '../../../../../../../lib/constants/apis';
import {
	removeNullDeep,
	removeDataKeys,
	getKostenKategorieArt,
	getOptionsFromRes,
	addIndexesToPath,
} from '../../../../../../../utils/helper';
import { useApplication } from '../../../../../../../context/ApplicationContext';
import AddIcon from '@mui/icons-material/Add';
import Schema from '../../../../../../../lib/paths/verwendungsnachweis_FULL_Paths.json';
import { Button } from '@mui/material';
import Grid2 from '@mui/material/Unstable_Grid2/Grid2';
import { cloneDeep } from 'lodash';
import { set } from 'lodash';
import CreateForm from '../../../../../../../components/ui-component/form-component/create-form/CreateForm';
import MUIAccordionComponent from '../../../../../../../components/ui-component/mui-accordion/MUIAccordionComponent';
import { FormStrucItem } from '../../../../../../../lib/types/types';
import { getFormStrucComponentTable } from '../../../../../../../utils/formStruc';
import { concat } from 'lodash';
const P = Schema.attributes;

const EigenmittelVN: FC<{ kostentraeger: string; unternehmenId?: number }> = ({ kostentraeger, unternehmenId }) => {
	const { application, setApplicationProperty, saveApplication, readOnly } = useApplication();
	const [kostenKategorie, setKostenKategorie] = useState([]);

	const handleAddEigenmittel = () => {
		try {
			let appCopy = cloneDeep(application);
			const data = {
				Kostentraeger: kostentraeger,
				Organisation: { id: unternehmenId },
				Entnahmekategorie: kostenKategorie[0],
				Einnahmen_Einnahmen_Block_1: [{ Zelle_1: '' }],
			};
			set(appCopy, `${P.Einnahmen.path}.${get(application, P.Einnahmen.path, []).length}`, data);
			saveApplication(false, appCopy);
		} catch (err: any) {
			console.error('ERROR: Adding Personalkosten ', err);
		}
	};

	const handleDeleteEigenmittel = (index: number) => {
		try {
			let appCopy = cloneDeep(application);
			const allKostenPosition = get(appCopy, P.Einnahmen.path, []);
			set(
				appCopy,
				P.Einnahmen.path,
				allKostenPosition.filter((_: any, i: number) => i !== index),
			);
			saveApplication(false, appCopy);
		} catch (err: any) {
			console.error('ERROR: Deleting Personalkosten ', err);
		}
	};

	useEffect(() => {
		const fetch = async () => {
			try {
				const filter = {
					Allgemein_Kostenposition: 'Einnahme',
					Allgemein_Kostenart_Finanzierung: 'Eigenmittel',
					Allgemein_Foerderprogramm: {
						$contains: get(application, P.Zuwendungsantrag.schema.attributes.Foerderprogramm.path + '.id'),
					},
				};
				let res = await GetRecords(APIS.KostenKategories, [], filter);

				setKostenKategorie(removeNullDeep(removeDataKeys(get(res, 'data', []))));
			} catch (err: any) {
				console.error('ERROR: Fetching Kostenkategories', err);
			}
		};
		fetch();
	}, []);

	return (
		<>
			{get(application, P.Einnahmen.path, []).map((ele: any, i: number) => {
				if (
					get(ele, 'Organisation.id') === unternehmenId &&
					get(ele, 'Kostentraeger') === kostentraeger &&
					getKostenKategorieArt(get(ele, 'Entnahmekategorie'), kostenKategorie) === 'Eigenmittel'
				) {
					return (
						<MUIAccordionComponent
							key={i}
							summaryTitle="Eigenmittel"
							onDelete={() => handleDeleteEigenmittel(i)}
							showDeleteButton={!readOnly}
						>
							<Grid2 container spacing={6}>
								<Grid2 sm={6}>
									<CreateForm
										formStruc={mapEigenmittel(strucEigenmittel(kostenKategorie), i)}
										formValues={application}
										updateFormValuesFunc={setApplicationProperty}
										readOnly={readOnly}
									/>
								</Grid2>
							</Grid2>
							<CreateForm
								formStruc={mapEigenmittel(formStrucErlaeuterungTable(application, i), i)}
								formValues={application}
								updateFormValuesFunc={setApplicationProperty}
								readOnly={readOnly}
							/>
						</MUIAccordionComponent>
					);
				}
			})}

			<Button sx={{ mt: '2rem' }} endIcon={<AddIcon />} onClick={handleAddEigenmittel} disabled={readOnly}>
				Eigenmittel hinzufügen
			</Button>
		</>
	);
};
export default EigenmittelVN;

const mapEigenmittel = (formStruc: any[], index: number) => {
	let result = formStruc.map((row) => {
		return {
			...row,
			fields: (get(row, 'fields', []) as Array<any>).map((value) => {
				let pathWithoutIndex = get(value, 'path', '') as string;
				return {
					...value,
					path:
						pathWithoutIndex.slice(0, P.Einnahmen.path.length) +
						`.${index}` +
						pathWithoutIndex.slice(P.Einnahmen.path.length),
				};
			}),
		};
	});
	return result;
};

const strucEigenmittel = (kostenKategorie: any) => {
	return [
		{
			fields: [
				{
					...P.Einnahmen.schema.attributes.Entnahmekategorie,
					type: 'enumeration',
					options: getOptionsFromRes(kostenKategorie, 'Allgemein_Bezeichnung'),
				},
			],
			userProps: { columnToDivide: 1 },
		},
	];
};

const formStrucErlaeuterungTable = (application: any, i: number) => {
	return [
		{
			fields: [
				{
					...P.Einnahmen.schema.attributes.Einnahmen_Einnahmen_Block_1,
					type: 'componentTable',
					hideColumns: [
						'Zelle_4',
						...(get(application, P.Verwendungsnachweisstatus_Status.path) === 'inBearbeitung'
							? ['Zelle_3', 'Zelle_5']
							: []),
					],
					disabledColumns: ['Zelle_4', 'Zelle_3', 'Zelle_5'],
					fieldProps: { Zelle_2: { format: 'currency', label: 'Verausgabt (€)' }, Zelle_3: { format: 'currency' } },
					sumRow: [
						{
							id: 'pinnedRow',
							Zelle_1: 'Zwischensumme',
							Zelle_2: get(
								application,
								addIndexesToPath(P.Einnahmen.schema.attributes.Zelle_2.path, [`${i}`], ['Einnahmen']),
							),
							Zelle_3: get(
								application,
								addIndexesToPath(P.Einnahmen.schema.attributes.Zelle_3.path, [`${i}`], ['Einnahmen']),
							),
						},
					],
				},
			],
			userProps: { columnToDivide: 1 },
		},
	];
};

export const GetVNEigenmittelFormStruc = (
	application: any,
	unternehmenId: number,
	kostentraeger: string,
	kostenKategorie: any,
) => {
	let formStruc: FormStrucItem[] = [];
	get(application, P.Einnahmen.path, []).forEach((ele: any, i: number) => {
		if (
			get(ele, 'Organisation.id') === unternehmenId &&
			get(ele, 'Kostentraeger') === kostentraeger &&
			getKostenKategorieArt(get(ele, 'Entnahmekategorie'), kostenKategorie) === 'Eigenmittel'
		) {
			const formStrucCT2WithIndex = getFormStrucComponentTable(
				application,
				mapEigenmittel(formStrucErlaeuterungTable(application, i), i),
			);
			const formStruc1WithIndex = mapEigenmittel(strucEigenmittel([]), i);
			formStruc = concat(formStruc, formStruc1WithIndex, formStrucCT2WithIndex);
		}
	});
	return formStruc;
};
